import React from 'react';
import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';
import styled from 'styled-components';

const StyledContainer = styled.div`
  .pricing-card-skeleton {
    min-height: 900px;
    min-width: 290px;
    color: #dcdcdc;
  }
    .placeholder-texts {
    margin-bottom: 20px;
    marin-top: 20px;
    font-size: 16px;
}

  @media (max-width: 768px) {
    .pricing-card-skeleton {
      min-height: 800px;
    }
  }
`;

const CardSkeletonLoader = () => {
    return (
        <StyledContainer>
            <Card className="pricing-card pricing-card-skeleton">
                <Card.Header>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={8} variant="light" />
                        <Placeholder xs={4} variant="light" />
                    </Placeholder>
                    <Placeholder.Button variant="light" xs={4} className="mt-2" />
                </Card.Header>
                <Card.Body>
                    {Array.from({ length: 15 }).map((_, idx) => (
                        <div key={idx} className='placeholder-texts'>
                            <Placeholder as="div" animation="glow" style={{ width: '100%', maxHeight: '12px' }}>
                                <Placeholder xs={10} />
                            </Placeholder>
                        </div>
                    ))}
                </Card.Body>
            </Card>
        </StyledContainer>
    );
};

export default CardSkeletonLoader;
